import { STORAGE_BUSINESS_PLAN_STATE } from "../constants/common";
export const useBusinessPlanState = () => {
    const rawBusinessPlanState = window.localStorage.getItem(STORAGE_BUSINESS_PLAN_STATE);
    const update = (state) => {
        try {
            if (state !== undefined) {
                window.localStorage.setItem(STORAGE_BUSINESS_PLAN_STATE, JSON.stringify(state));
            }
            else {
                window.localStorage.removeItem(STORAGE_BUSINESS_PLAN_STATE);
            }
        }
        catch (e) {
            // ...
        }
    };
    return [rawBusinessPlanState !== undefined ? JSON.parse(rawBusinessPlanState) : undefined, update];
};
